import React from 'react';
import { Page } from 'react-onsenui';
import Toolbar from '../../headers/actions/Toolbar';
import './ActionFormLayouts.css';
import PropTypes from 'prop-types';
import { Button } from 'antd-mobile';

const Layouts = props => {
    return (
        <Page
            renderToolbar={() => <Toolbar title={props.title} previousStep={props.previousStep} />}
            modifier='ls_page_action_form'
            style={props.style}
            onShow={props.onShow}
            id={props.id}
        >
            {props.children}
            <div style={{position: props.position || 'absolute',top: 'auto', bottom: '0', margin: '20px', width: '88%'}}>
                {
                    (props.showBtn) && 
                    <Button
                        loading={props.isOnSubmit}
                        style={{textTransform: 'uppercase', backgroundColor: '#004586', color: '#fff', fontFamily: 'fff-equipe', borderRadius: '50px', fontSize: '16px'}} 
                        disabled={!props.enabled} 
                        onClick={props.submit}
                    >
                        {props.okBtn || 'valider'}
                    </Button>}
            </div>
        </Page>
    )
}

Layouts.propTypes = {
    title: PropTypes.string,
    enabled: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]).isRequired,
    submit: PropTypes.func,
    children: PropTypes.element,
    okBtn: PropTypes.string,
    style: PropTypes.object,
    onShow: PropTypes.func,
    id: PropTypes.string,
    previousStep: PropTypes.func,
    showBtn: PropTypes.bool,
    isOnSubmit: PropTypes.bool,
    position: PropTypes.string
}

export default Layouts;